import styled from "@emotion/styled";
import PropTypes from "prop-types";
import { equals } from "ramda";
import React, { Suspense } from "react";

import theme from "../../theme";
import FilterButton from "../Button/Filter";
import { h5 } from "../Typography";

const Wrapper = styled.nav`
  overflow: auto;
  padding: ${theme.space("xxs")};
  padding-bottom: ${theme.space("xs")};
`;

const ScrollWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const FilterIntro = styled.span`
  ${h5}
  padding: ${theme.space("xs")} 0;
  margin-right: ${theme.space("xs")};
`;

const FilterItem = styled(FilterButton)`
  flex: 0 0 auto;
`;

function Filter({ items, activeFilter, onChange, ...props }) {
  const isSSR = typeof window === "undefined";
  return (
    !isSSR && (
      <Suspense fallback={<div />}>
        <Wrapper {...props}>
          <ScrollWrapper>
            <FilterIntro>Toon:</FilterIntro>
            {items.map((item) => (
              <FilterItem
                key={item.id ? item.id : item}
                active={equals(activeFilter, item)}
                onClick={() => onChange(item)}
              >
                <span>{item.label ? item.label : item}</span>
              </FilterItem>
            ))}
          </ScrollWrapper>
        </Wrapper>
      </Suspense>
    )
  );
}

export const filterItem = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  text: PropTypes.string,
  url: PropTypes.string,
};

Filter.propTypes = {
  items: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.shape(filterItem)),
  ]),
  activeFilter: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape(filterItem),
  ]),
  onChange: PropTypes.func,
};

Filter.defaultProps = {
  onChange: () => {},
};

export default Filter;
